export enum paths {
	game = '/game/',
	search = '/search=',
	profile = '/profile/',
}
